<div class="dialog-title">
  <h3> {{data.title}}</h3>

  <span mat-button mat-dialog-close>
      <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
          <path id="close-btn"
              d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
              transform="translate(5.82 13.32)" fill="#bbb" />
      </svg>
  </span>
</div>

<mat-dialog-content>
  <div class="confirm_img">
      <mat-icon>{{data.icon}}</mat-icon>
  </div>
  <div class="confirm_text">
      <p>
          {{data.text}}
      </p>
  </div>
  <div class="group_btn mt-3">
      <button mat-dialog-close mat-button class="btnLight_fill" [appLoading]="loading">{{data.cancel}}</button>
      <button (click)="confirm()" mat-button class="btn_fill" [appLoading]="loading">{{data.confirm}}</button>
  </div>
</mat-dialog-content>